// Fix for ResizeObserver loop error
// This prevents the "ResizeObserver loop completed with undelivered notifications" error
// that occurs when components are rapidly resized or unmounted

const originalResizeObserver = window.ResizeObserver;

window.ResizeObserver = class ResizeObserver extends originalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      try {
        callback(entries, observer);
      } catch (error) {
        // Swallow ResizeObserver loop errors
        if (error.message && error.message.includes('ResizeObserver loop')) {
          return;
        }
        // Re-throw other errors
        throw error;
      }
    });
  }
};
